module.exports = __webpack_public_path__ + "img/health-preview.71606624.png";